import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSurveyQnsAction = createAsyncThunk(
    'get-survey-qns',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-survey-link_qns?sub_cat_id=${data?.sub_cat_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSurveyQnsSlice = createSlice({
    name: 'get-survey-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSurveyQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSurveyQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSurveyQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSurveyQnsReducer = getSurveyQnsSlice.reducer    